import React, { useMemo, useRef, useEffect } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "./RichTextEditor.css";

function RichTextEditor({ value, onChange, placeholder, id, onSubmitHotkey, ...rest }) {
  // Keep callback in a ref so modules can remain stable
  const submitRef = useRef(onSubmitHotkey);
  useEffect(() => {
    submitRef.current = onSubmitHotkey;
  }, [onSubmitHotkey]);

  // Stable modules object to prevent Quill re-instantiation on each render
  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
      ],
      clipboard: {
        matchVisual: false,
      },
      keyboard: {
        bindings: {
          submit: {
            key: 13, // Enter
            shortKey: true, // Cmd/Ctrl
            handler: () => {
              if (typeof submitRef.current === "function") {
                submitRef.current();
                return false; // prevent default new line when submitting
              }
              return true;
            },
          },
        },
      },
    }),
    [],
  );

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
  ];

  return (
    <div className="rte" id={id}>
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        formats={formats}
        placeholder={placeholder}
        {...rest}
      />
    </div>
  );
}

export default RichTextEditor;
